import parse from "color-parse";

export const COLOR_MAP = {
  Gray: "var(--gray)",
  Blue: "var(--blue)",
  Orange: "var(--orange)",
  Green: "var(--green)",
  Red: "var(--red)",
  SoftBlue: "var(--soft-blue)",
  SoftOrange: "var(--soft-orange)",
  SoftGreen: "var(--soft-green)",
  SoftRed: "var(--soft-red)"
};

export interface Color {
  r: number;
  g: number;
  b: number;
  a: number;
}

export { parse };

export const parseColor = (color: string | null | undefined): Color | null => {
  if (!color) return null;

  const parsed = parse(color);
  if (parsed.values.length) {
    return {
      a: parsed.alpha,
      r: parsed.values[0],
      g: parsed.values[1],
      b: parsed.values[2]
    };
  }

  return null;
};

export const colorToRGBA = (color: Color): string => `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;

export const isSameColor = (a: string, b: string): boolean => {
  if (a === b) return true;
  if (!a && !b) return true;
  if (!a || !b) return false;

  const ac = parseColor(a)!;
  const bc = parseColor(b)!;
  return ac.a === bc.a && ac.r === bc.r && ac.g === bc.g && ac.b === bc.b;
};

export const isColorLike = (value: string | undefined | null): boolean => {
  if (!value) return false;

  if (value.toLowerCase() === "transparent") return true;
  if (value.startsWith("#") || value.startsWith("rgb(") || value.startsWith("rgba(")) return true;
  return false;
};

/**
 * @param c HEX, RGB, RGBA
 * @param opacity [0, 1]
 * @returns RGBA color
 */
export const changeOpacity = (c: string, opacity: number | string): string => {
  const color = parseColor(c);
  if (color) {
    color.a = +opacity.toString();
    return colorToRGBA(color);
  }
  return c;
};
